module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "message",
      "id": "message",
      "rows": "2",
      "textarea": "",
      "required": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "success--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendMessage($event)
      }
    }
  }, [_vm._v("send")]), _vm._v(" "), _c('file-modal', {
    ref: "file_modal"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e560efe4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/MessageForm.vue
// module id = 226
// module chunks = 1